import { useState } from 'react';

import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/new';
import { Inline, Stack, Text, xcss } from '@atlaskit/primitives';

import { useRelationshipsAnalytics } from '../../hooks';
import { BaseCard } from '../base-card';
import { RequestAssistanceModal } from '../request-assistance-modal';

import { messages } from './messages';

const contentStyles = xcss({
	height: '100%',
});

export const RequestSupportCard = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { sendRequestAssistanceButtonClickUIEvent } = useRelationshipsAnalytics();

	const handleRequestAssistanceClick = () => {
		sendRequestAssistanceButtonClickUIEvent();
		setIsModalOpen(true);
	};

	return (
		<BaseCard message={messages.requestSupportCardTitle}>
			<Stack xcss={contentStyles} space="space.100" spread="space-between">
				<Text>
					<FormattedMessage {...messages.requestSupportCardDescription} />
				</Text>

				<Inline alignBlock="end">
					<RequestAssistanceModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
					<Button onClick={handleRequestAssistanceClick}>
						<FormattedMessage {...messages.requestSupportCardButton} />
					</Button>
				</Inline>
			</Stack>
		</BaseCard>
	);
};
